import React, {useState, useRef, useCallback} from 'react';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
    Container,
    Grid,
    Typography,
    makeStyles,
    Button
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import getApiConnectorRoute from "../apiRoutes";
import ServerTable from "components/ServerTable";
import ConnectorListActions from "./ListActions";
import {getProcessorIcon} from 'helpers';

const useStyles = makeStyles(() => ({
    root: {},
    button: {
        borderTopLeftRadius: "0",
        borderBottomLeftRadius: "0"
    }
}));

const ConnectorList = ({ AppValues, secureFetch, ...rest }) => {
    const classes = useStyles();
    const [rowsData, setRowsData] = useState([]);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation('connector');
    const tableFilter = useRef(null);
    const navigate = useNavigate();

    const loadData = useCallback((pConditions = null) => {
        setLoading(true);
        secureFetch(getApiConnectorRoute('list')).then(data => {
            setLoading(false);
            setRowsData(data);
        });
    }, [secureFetch, AppValues.user])

    const settings = {
        rows: rowsData,
        loading: loading,
        colOrder: {
            order: 'desc',
            order_by: 'created_at'
        },
        refFilter: tableFilter,
        handleTableUpdate: loadData,
        headCells: [
            { id: 'name', numeric: false, label: t('label.name'), search: false, disableOrder: false },
            { id: 'processor', numeric: false, label: t('label.type'), search: false, disableOrder: false, render: (data) => getProcessorIcon(data) },
            { id: 'actions', numeric: true, label: t('label.actions'), search: false, disableOrder: true, render: (data) => <ConnectorListActions connector={data} loadData={loadData} /> },
        ],
        topRightButtons: () => (
            <Button
                variant="contained"
                color="primary"
                className={classes.button}
                size="small"
                startIcon={<AddIcon />}
                onClick={() => {
                    navigate('/app/connector/new', {
                        state: {
                            id: null,
                            processor: null
                        }
                    });
                }}
            >
                {t('button.new_connector')}
            </Button>
        ),
        topLeftButtons: () => {},
        rowClass: (data) => {
            return '';
        },
        addFilter: false,
        allowPagination: false
    };

    return (
        <Container maxWidth={false}>
                    <Typography variant="h1" gutterBottom >
                        {t('title.list_of_connectors')}
                    </Typography>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <ServerTable settings={settings} />
                        </Grid>
                    </Grid>
                </Container>
    )
}

export default ConnectorList;